import React from 'react';
import { Field } from 'react-final-form';
import PropTypes from 'prop-types';
import { ErrorMessage } from './ErrorMessage';
import { requireTrueUtil } from '../utils';

const GenericCheckboxInputField = ({
    name,
    label,
    className,
    fieldClassName,
    disabled,
    required,
    errorMsg,
    defaultValue,
}) => {
    const inputcss = className || 'h-5 w-5';
    const fieldcss = fieldClassName || 'flex pt-2 pl-1';
    return (
        <Field
            name={name}
            validate={required ? requireTrueUtil(errorMsg) : undefined}
            initialValue={defaultValue}
        >
            {({ input, meta }) => (
                <div>
                    <div className={fieldcss}>
                        <input
                            {...input}
                            name={name}
                            className={inputcss}
                            type={'checkbox'}
                            checked={input.value}
                            disabled={disabled}
                            data-testid={name}
                        />
                        <div className={'text-gray-700 mb-1 md:mb-0 pl-2'}>
                            {label}
                            {required && (
                                <span className="text-sm text-red-500 my-0 md:mb-0">
                                    *{' '}
                                </span>
                            )}
                        </div>
                    </div>
                    <ErrorMessage meta={meta} />
                </div>
            )}
        </Field>
    );
};

GenericCheckboxInputField.propTypes = {
    name: PropTypes.string,
    label: PropTypes.oneOfType([PropTypes.element, PropTypes.string]),
    className: PropTypes.func,
    fieldClassName: PropTypes.func,
    disabled: PropTypes.bool,
    required: PropTypes.bool,
    errorMsg: PropTypes.string,
    defaultValue: PropTypes.bool,
};

export default GenericCheckboxInputField;
